import { Component, Input, OnInit, Renderer2, ViewChild } from '@angular/core';
import { createNumberMask } from 'text-mask-addons/dist/textMaskAddons';
import { MessageService } from '@services/helpers/message-service/message.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { SNModalService } from '@web-services/modal/snModal.service';
import { IModalAction, IProductPackageItem } from '@models/models';
import { ProductPackageService } from '@web-services/settings/productPackage.service';

@Component({
	selector: 'update-package-product-modal',
	template: require('./update-package-product-modal.component.html')
})
export class UpdatePackageProductModalComponent implements OnInit {
	@ViewChild('editor') editor;

	@Input() modalTitle: string;
	@Input() modalData: IProductPackageItem;
	@Input() btnDisabled: boolean;
	@Input() name: string;

	currensySymbol: string;
	numberMask: any;
	descriptionMaxLength = 4000;

	constructor(
		private productPackageService: ProductPackageService,
		private messageService: MessageService,
		public activeModal: NgbActiveModal,
		private modalService: SNModalService
	) {}

	ngOnInit(): void {
		this.currensySymbol = this.productPackageService.getCurrensySymbol();
		this.numberMask = createNumberMask({
			prefix: this.currensySymbol,
			suffix: '',
			allowDecimal: true,
			allowLeadingZeroes: true,
			allowNegative: false
		});
	}

	private prepareValueToValidate(): IProductPackageItem {
		let { name, description, price, taxType, type } = JSON.parse(
			JSON.stringify(this.modalData)
		);

		name = name.trim();

		if (description) {
			const _description = description.replace(/&nbsp;/g, '');
			description = _description.replace(/ /g, '');
		}

		return { name, description, price, taxType, type };
	}

	convertAmountIntoNumber(value: any): number {
		if (isNaN(value)) {
			const regExp = new RegExp(`[${this.currensySymbol},]`, 'g');
			const a = value.replace(regExp, '');
			return +a;
		}

		return +value;
	}

	private validateModalValue(): boolean {
		let validated = true;
		const { name, description, price, taxType } = this.prepareValueToValidate();

		const invalidCounter = document.querySelector('.counter.red');

		if (!name || name === '') {
			validated = false;
			this.messageService.showToaster(
				'e_0',
				'productsPackages',
				this.name.toLowerCase()
			);
		} else if (!description || description === '' || description.length === 7) {
			validated = false;
			this.messageService.showToaster(
				'e_3',
				'productsPackages',
				this.name.toLowerCase()
			);
		} else if (!price || price === '') {
			validated = false;
			this.messageService.showToaster(
				'e_2',
				'productsPackages',
				this.name.toLowerCase()
			);
		} else if (!taxType || taxType === '') {
			validated = false;
			this.messageService.showToaster('e_1', 'productsPackages');
		} else if (invalidCounter) {
			validated = false;
			this.messageService.showToaster(
				'e_6',
				'productsPackages',
				this.descriptionMaxLength.toString()
			);
		}

		return validated;
	}

	private prepareValueToEmit(): IModalAction<IProductPackageItem> {
		this.modalData.price = this.convertAmountIntoNumber(this.modalData.price);

		this.modalData.name = this.modalData.name.trim();

		return {
			action: this.modalTitle,
			props: this.modalData
		};
	}

	onSubmit(): void {
		if (this.validateModalValue()) {
			const modalDataToSend = this.prepareValueToEmit();
			this.modalService.setModalData(modalDataToSend);
		}
	}

	onDismiss(): void {
		this.activeModal.dismiss();
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=oom9nsliule!./web/modern/components/packages-product/modals/update-package-product-modal/update-package-product-modal.component.ts